const devTemplates = [];

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "DebugBox"
    }), getStaticProps: () => ({
        id: "debug_box",
        icon: "debug_box",
        title: "Debug Box",
        category: "organization",
        tags: "",
    })
});

devTemplates.push({
    getInstanceProps: () => ({
        elementType: "SlideLayoutCanvas",
        allowHeader: false,
        allowFooter: false,
        availableTrayLayouts: [],
    }), getStaticProps: () => ({
        id: "slide_layout_canvas",
        icon: "debug_box",
        title: "Slide Layout Canvas",
        category: "organization",
        tags: "",
    })
});

module.exports = devTemplates;
